// Schemas describing the editable fields for each collection slug.
// Each field: { key, label, type, options?, required?, placeholder?, helper? }
// Supported types: text, textarea, switch, select, array (newline-separated string list)

export const COLLECTION_META = {
  companies: {
    title: "Companies",
    description: "Businesses and ventures shown in the Companies section.",
    primaryKey: "name",
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "url", label: "URL", type: "text", required: true, placeholder: "https://example.com" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "initials", label: "Initials (2 chars)", type: "text", placeholder: "e.g. TG" },
    ],
  },
  portfolio: {
    title: "Portfolio",
    description: "Full Creations & Portfolio grid (websites and apps).",
    primaryKey: "name",
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "url", label: "URL", type: "text", required: true, placeholder: "https://example.com" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "type", label: "Type", type: "text", placeholder: "e.g. Web Application" },
    ],
  },
  featured_projects: {
    title: "Favorite Projects",
    description: "Curated showcase that appears between Companies and Portfolio.",
    primaryKey: "name",
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "url", label: "URL", type: "text", required: true, placeholder: "https://example.com" },
      { key: "tagline", label: "Tagline", type: "text", placeholder: "Short punchy line" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "type", label: "Type / status", type: "text", placeholder: "e.g. App · Live" },
      {
        key: "accent",
        label: "Accent color",
        type: "select",
        options: [
          { value: "primary", label: "Primary (magenta)" },
          { value: "accent", label: "Accent (gold)" },
          { value: "amber", label: "Amber" },
          { value: "sky", label: "Sky" },
          { value: "rose", label: "Rose" },
          { value: "green", label: "Green" },
        ],
      },
      {
        key: "icon",
        label: "Icon",
        type: "select",
        options: [
          { value: "HeartHandshake", label: "HeartHandshake" },
          { value: "BookHeart", label: "BookHeart" },
          { value: "CupSoda", label: "CupSoda" },
          { value: "Search", label: "Search" },
          { value: "Sparkles", label: "Sparkles" },
          { value: "Star", label: "Star" },
        ],
      },
      { key: "highlights", label: "Highlights (one per line)", type: "array" },
    ],
  },
  experience: {
    title: "Experience",
    description: "Career timeline shown in the Experience section.",
    primaryKey: "company",
    fields: [
      { key: "company", label: "Company", type: "text", required: true },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "department", label: "Department (optional)", type: "text" },
      { key: "location", label: "Location (optional)", type: "text" },
      { key: "dates", label: "Dates", type: "text", placeholder: "e.g. 2014 - 2019 or Present" },
      { key: "current", label: "Current role", type: "switch" },
      { key: "bullets", label: "Bullets (one per line)", type: "array" },
    ],
  },
};
